export default __webpack_public_path__ + "static/media/Learn_async_JS_-_adamr.space___Codecademy.16d1e801.pdf";